import GalleryView from "image-gallery/v5";
import Dialog from '@mui/material/Dialog';
export const ImageGallery = ({ setOpenImageGallery, openImageGallery, carouselItems, videoUrl, downloadUrl }) => {
    const updatedCarouselItems = videoUrl ? carouselItems
        .filter((_, index) => index > 0)
        .map(item => `${downloadUrl}/${item}`) : carouselItems.map((item) => {
            return `${downloadUrl}/${item}`
        })

    const handleCloseAllImages = () => {
        setOpenImageGallery(false)
    }
    return <Dialog
        PaperProps={{
            style: {
                maxWidth: "850px",
                overflow: "hidden",
            },
        }}
        fullScreen={true}
        open={openImageGallery}
        onClose={handleCloseAllImages}
    >
        <GalleryView
            showImageControls={true}
            handleBack={handleCloseAllImages}
            images={updatedCarouselItems}
        />
    </Dialog>
}